import React, { Component } from 'react';
import { variables } from "../Variables.js"
import { getToken, getRoles, getUsername } from '../TokenController';
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { TableVirtuoso } from 'react-virtuoso'

const TableComponents = {
    Scroller: React.forwardRef((props, ref) => <TableContainer component={Paper} {...props} ref={ref} />),
    Table: (props) => <Table {...props} style={{ borderCollapse: 'separate' }} />,
    TableHead: TableHead,
    TableRow: TableRow,
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
}

export default class CsTable extends React.Component {



    constructor(props) {
        super(props);
        this.state = {
            assetid: '',
            text: '',
            assets: [],
            refresh: true,
            canEdit: false

        };
        console.log(this.props.selectedRoot)
        this.getData("")
    }

   

    async getData(tkn) {

        tkn = await getToken();
        console.log("Token " + tkn)
        return fetch(`${variables.API_URL}/api/assets/all/${this.props.selectedRoot}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tkn,
            }
        })
            .then((response) => response.json()).then(data => {
                console.log(data)
                this.setState({
                    assets: data
                })
            })
            .catch(() => { throw new Error('Data Loading Error'); });
    }

   

    
    render() {
        return (
            <div>
            <h2>{this.props.selectedRoot}</h2>
                <TableVirtuoso
                    style={{ height: 600, width: 1000 }}
                    data={this.state.assets}
                    components={TableComponents}
                    fixedHeaderContent={() => (
                        <TableRow>
                            <TableCell style={{ width: 50, background: 'white' }}>
                                Position
                            </TableCell>
                            <TableCell style={{ width: 20, background: 'white' }}>
                                Type
                            </TableCell>
                            <TableCell style={{ width: 20, background: 'white' }}>
                                Description
                            </TableCell>
                            <TableCell style={{ width: 20, background: 'white' }}>
                                Resposible
                            </TableCell>
                        </TableRow>
                    )}
                    itemContent={(index, asset) => (
                        <>
                            <TableCell style={{ width: 50, background: 'white' }}>
                                {asset.id}
                            </TableCell>
                            <TableCell style={{ width: 20, background: 'white' }}>
                                {asset.assetType}
                            </TableCell>
                            <TableCell style={{ width: 20, background: 'white' }}>
                                {asset.text}
                            </TableCell>
                            <TableCell style={{ width: 20, background: 'white' }}>
                                {asset.responsible}
                            </TableCell>
                        </>
                    )}
                />
            </div>

        );
    }
}